<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <Box theme="box-primary" title="Tìm kiếm">
        <div slot="content">
          <div class="form-group col-md-3 col-sm-6 col-xs-12">
            <label>Loại thanh toán</label>
            <b-form-select
              id="pageSize"
              v-model="type"
              :options="types"
              required
            ></b-form-select>
          </div>
          <div class="form-group col-md-9 col-sm-6 col-xs-12">
            <b-button variant="success" @click="search" style="margin-top: 25px">
              <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
            </b-button>
          </div>
        </div>
      </Box>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <Box theme="box-primary" title="Danh sách thanh toán">
        <div slot="content">
          <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                   show-empty>
            <template #table-busy>
              <div class="text-center my-2 mt-5 mb-5">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Đang tải...</strong>
              </div>
            </template>

            <template #empty="scope">
              <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
            </template>

            <template v-slot:cell(type)="data">
              {{data.item.type === 'NEW_BUY' ? 'Thanh toán 1 lần' : 'Thanh toán định kỳ'}}
            </template>
            <template v-slot:cell(status)="data">
              {{ data.item.status === 'WAITING_APPROVAL' ? 'Chờ xác nhận' : (data.item.status === 'APPROVED' ? 'Đã duyệt' : data.item.status === 'DISAPPROVED' ? 'Không duyệt' : data.item.status === 'DELETED' ? 'Đã xóa' : 'Hủy bởi kế toán') }}
            </template>
            <template v-slot:cell(value)="data">
              <span v-if="!data.item.editMode">{{data.item.value | format_currency}}</span>
              <currency-input v-else v-model.number="data.item.value" placeholder="Nhập số tiền thanh toán ..."/>
            </template>
            <template v-slot:cell(invoice_no)="data">
              <span v-if="!data.item.editMode">{{data.item.invoice_no}}</span>
              <input v-else type="text" class="form-control" v-model="data.item.invoice_no"
                     placeholder="Nhập số hoá đơn..."/>
            </template>
            <template v-slot:cell(sale_note)="data">
              <span v-if="!data.item.editMode">{{data.item.sale_note}}</span>
              <textarea v-else class="form-control" id="textarea1"
                v-model="data.item.sale_note"
                rows="3"
                style="height: 71px!important;"
              ></textarea>
            </template>
            <template v-slot:cell(created_at)="data">
              {{data.item.created_at | format_date_time}}
            </template>
            <template v-slot:cell(payment_method)="data">
              <span v-if="!data.item.editMode">{{data.item.payment_method === 'CASH' ? 'Tiền mặt' : (data.item.payment_method === 'CARD' ? 'Thẻ' : (data.item.payment_method === 'TRANSFER' ? 'Chuyển khoản' : ''))}}</span>
              <multiselect v-else v-model="data.item.payment_method" :options="paymentMethods" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </template>

            <template v-slot:cell(actions)="data">
              <b-button v-if="data.item.editMode" variant="warning" v-b-tooltip.hover title="Lưu" @click="save(data.item)" :disabled="data.item.status !== 'WAITING_APPROVAL'"><i class="fa fa-floppy-o"/></b-button>
              <b-button v-if="!data.item.editMode" variant="warning" v-b-tooltip.hover title="Sửa" @click="edit(data.item)" :disabled="data.item.status !== 'WAITING_APPROVAL'"><i class="fa fa-edit"/></b-button>
              <b-button v-if="data.item.editMode" variant="danger" v-b-tooltip.hover title="Huỷ" @click="discard(data.item)" :disabled="data.item.status !== 'WAITING_APPROVAL'"><i class="fa fa-times"/></b-button>
              <b-button v-if="!data.item.editMode" variant="danger" v-b-tooltip.hover title="Hủy thanh toán" @click="remove(data.item)" :disabled="data.item.status !== 'WAITING_APPROVAL'"><i class="fa fa-trash"/></b-button>
            </template>

          </b-table>
        </div>
      </Box>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-between">
      <div class="page-size-container">
        <span>Hiển thị</span>
        <b-form-select
          id="pageSize"
          v-model="pageSize"
          :options="pageSizes"
          required
        ></b-form-select>
        <span>  dòng</span>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRow"
        :per-page="pageSize"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import Box from '../../components/Box'
import Utils from '../../common/utils'
import PaymentApi from '../../api/payment'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'

export default {
  name: 'OrderPaymentHistory',
  components: {
    Box,
    Multiselect
  },
  props: {
    orderId: {
      type: Number,
      required: false,
    },
    onPaymentChanged: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      type: null,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      types: [
        {text: 'Thanh toán mua 1 lần', value: 'NEW_BUY'},
        {text: 'Thanh toán định kỳ', value: 'ANNUAL_BUY'}
      ],
      fields: [
        {
          key: 'id',
          label: 'STT',
          show: true
        }, {
          key: 'status',
          label: 'Trạng thái',
          show: true
        }, {
          key: 'type',
          label: 'Loại thanh toán',
          show: true
        }, {
          key: 'value',
          label: 'Số tiền',
          show: true
        }, {
          key: 'auto_picked_order_details',
          label: 'Danh sách mã sản phẩm',
          show: true
        }, {
          key: 'sale_note',
          label: 'Ghi chú của sale',
          show: true
        }, {
          key: 'accountant_note',
          label: 'Ghi chú kế toán',
          show: true
        }, {
          key: 'payment_method',
          label: 'Phương thức thanh toán',
          show: true
        }, {
          key: 'invoice_no',
          label: 'Mã chứng từ',
          show: true
        }, {
          key: 'created_at',
          label: 'Ngày tạo',
          show: true
        }, {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 100px',
          class: 'actions-cell',
          show: true
        }
      ],
      items: [],
      paymentMethods: [
        {text: 'Tiền mặt', value: 'CASH'},
        {text: 'Thẻ', value: 'CARD'},
        {text: 'Chuyển khoản', value: 'TRANSFER'}
      ]
    }
  },
  mounted () {
    if (this.orderId) {
      this.filter()
    }
  },
  methods: {
    buildFilterData () {
      if (this.type) {
        return {order_id: this.orderId, type: this.type}
      }
      return {order_id: this.orderId}
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      PaymentApi.filter(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    edit (selectedRow) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          item.editMode = true
          let payment_method_value = ''
          if (typeof selectedRow.payment_method === 'string') {
            payment_method_value = selectedRow.payment_method
          } else {
            payment_method_value = selectedRow.payment_method.value
          }
          console.log(payment_method_value)

          item.payment_method = {
            value: payment_method_value,
            text: this.paymentMethods.find(item => item.value === payment_method_value).text
          }
        }
        return item
      })
    },
    save (selectedRow) {
      if (this.saving) {
        return
      }
      this.saving = true
      this.loading = true
      selectedRow.payment_method = selectedRow.payment_method.value
      PaymentApi.update(selectedRow).then(res => {
        this.loading = false
        this.saving = false
        this.items = this.items.map(item => {
          item.editMode = false
          return item
        })
        Utils.successToast(this.$bvToast)
        this.onPaymentChanged()
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    discard (selectedRow) {
      this.items = this.items.map(item => {
        item.editMode = false
        return item
      })
    },
    remove (item) {
      if (item && item.id) {
        this.$bvModal.msgBoxConfirm('Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            PaymentApi.remove(item.id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
              this.onPaymentChanged()
              this.$bvModal.hide('listSelectProductModal' + this.type)
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderPaymentHistory.vue